module.exports = __webpack_public_path__ + "img/carinfo-bg.6abc287e.png";